export default "__VITE_ASSET__C3R$esyt__"